

























































import {Component, Vue, Watch} from "vue-property-decorator";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {ReceiptExpensesPickingListTargetType, ReceiptPaymentType} from "@/enums/type";
import {cloneDeep, difference} from "lodash";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {ReceiptEmployeeStore} from "@/modules/receiptsexpenses/receiptemployee/store";
import {ReceiptEmployeeParams} from "@/modules/receiptsexpenses/receiptemployee/params";
import {DebtEmployee} from "@/interfaces/entity";
import {union} from "lodash";
import ReceiptDebtEmployeeTable
    from "@/modules/receiptsexpenses/receiptemployee/Form/components/ReceiptDebtEmployeeTable/index.vue";
import ConfirmReceiptExpense from "@/modules/receiptsexpenses/shared/components/ConfirmReceiptExpense/index.vue";
import {EmployeeStore} from "@/modules/employees/store";
import PrintReceiptExpense from "@/modules/receiptsexpenses/shared/components/PrintReceiptExpense/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import ReceiptEmployeePickingListPrint from "@/modules/receiptsexpenses/receiptemployee/shared/Print/index.vue";
import {ReceiptPartnerStore} from "@/modules/receiptsexpenses/receiptpartner/store";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

const form = {
    paymentType: undefined,
    debtIds: [],
    employeeRowGuid: undefined,
    note: undefined,
    bankAccount: undefined
};

@Component({
    name: "ReceiptEmployeeForm",
    components: {
        AInputBarCode,
        ReceiptEmployeePickingListPrint,
        PrintReceiptExpense,
        ConfirmReceiptExpense, ReceiptDebtEmployeeTable, LadingPaymentTypeLabel, EnumSelector, EmployeeSelector
    }
})
export default class extends Vue {
    ReceiptPaymentType = ReceiptPaymentType;
    form = cloneDeep(form);
    ladingCode = "";
    selectedIds: number[] = [];
    isSaving = false;
    visibleConfirm = false;

    receiptPickingListId = null as any;
    printObj = {
        id: "receipt-employee-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    }

    created() {
        ReceiptEmployeeStore.clearDebtEmployeeStore();
    }

    @Watch("form.employeeRowGuid")
    onChangeEmployeeRowGuid(val: any) {
        this.form.debtIds = [];
        if (!val) return;
        ReceiptEmployeeStore.listDebtEmployee({...new ReceiptEmployeeParams(), targetRowGuid: val, limit: 2000});
    }


    onChangeLadingCode(evt: any) {
        console.log("uppercase", evt?.target?.value?.toUpperCase())
        const val = evt?.target?.value;
        const debtIds: number[] = this.debtEmployees
            .filter((debt: DebtEmployee) => debt.billLading?.ladingCode === val.toUpperCase())
            .map((debt: DebtEmployee) => debt.id);
        this.form.debtIds = union(this.form.debtIds, debtIds) as any;
        setTimeout(() => this.ladingCode = "", 500);
    }

    get debtEmployees() {
        return ReceiptEmployeeStore.ids.map((id: number) => ReceiptEmployeeStore.data[id]);
    }

    get dataConfirm() {
        const debts = this.form.debtIds.map((id: number) => ReceiptEmployeeStore.data[id]);
        const totalMoney = debts.reduce((prev, current: DebtEmployee, index, array) => {
            const money = current?.money
            return prev + (money ? money : 0)
        }, 0);
        const target = {
            type: ReceiptExpensesPickingListTargetType.Employee,
            name: this.form.employeeRowGuid ? EmployeeStore.data[this.form.employeeRowGuid as any]?.fullname : ''
        }
        return {
            debts,
            target,
            isExpense: false,
            totalMoney
        }
    }

    onSelectedIdsChange(selectedIds: any) {
        this.form.debtIds = selectedIds;
    }

    async onSave() {
        try {
            if (!this.isValidForm()) return;
            this.isSaving = true;
            const data = await ReceiptEmployeeStore.receiptEmployee(this.form);
            this.receiptPickingListId = data.id;
            this.$message.success("Thu tiền nhân viên thành công");
            (this.$refs.printReceiptExpense as any).$el.click();
            this.refresh();
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
        }
        this.isSaving = false;
        this.visibleConfirm = false;
    }

    confirm() {
        if (!this.isValidForm()) return;
        this.visibleConfirm = true;
    }

    isValidForm() {
        if (!this.form.employeeRowGuid) {
            this.$message.error("Vui lòng chọn nhân viên");
            return false;
        }
        if (!this.form.debtIds.length) {
            this.$message.error("Vui lòng quét mã vận đơn để thu");
            return false;
        }
        if (!this.form.paymentType) {
            this.$message.error("Vui lòng chọn hình thức thanh toán");
            return false;
        }
        return true;
    }

    refresh() {
        this.ladingCode = "";
        this.form = cloneDeep(form);
        ReceiptEmployeeStore.clearDebtEmployeeStore();
    }

    acceptDebt() {
        const deletedDebtEmployeeIds = difference(ReceiptEmployeeStore.ids, this.form.debtIds);
        ReceiptEmployeeStore.deleteDebtEmployeeByIds(deletedDebtEmployeeIds);
    }
}
